import React, { useRef, useMemo } from 'react';
import { DatePicker, Divider } from 'antd';
import moment from 'moment';
import { FixMe } from '@utils/types';
import Report, { IReport, ReportHeader } from './Report';
import { MetricProps } from './metricModal';
import classes from './sync-report-common.module.scss';
import { UnsuccessfulEventErrorProps } from './errors';
import useInfiniteScroll from '@hooks/useInfiniteScroll';
import { useCloudSourceInfo } from '@stores/cloudSourcesInfo/cloudSourcesInfo';
import Loading from '@ui-library/Loading';

const { RangePicker } = DatePicker;
export interface SyncsProps {
  reports: IReport[];
  sourceName: string;
  sourceCreatedAt: string;
  destinationName: string;
  onChangeDate: (date: { from: string; to: string }) => void;
  onClickRecords?: (data: MetricProps) => void;
  onClickRejected: (data: UnsuccessfulEventErrorProps) => void;
  operationMetrices?: MetricProps;
}

const Syncs = ({
  reports,
  sourceName,
  sourceCreatedAt,
  destinationName,
  onChangeDate,
  onClickRecords,
  onClickRejected,
  operationMetrices,
}: SyncsProps) => {
  const { getDownDirectionRunHistory, loadingReports, canLoadMore } = useCloudSourceInfo();

  const loadMore = useMemo(
    () => async () => {
      await getDownDirectionRunHistory(false);
    },
    [],
  );

  const endPageRef = useRef(null);
  useInfiniteScroll(endPageRef, loadMore);

  const noReportsView = !loadingReports && <Divider>No syncs found</Divider>;

  const loadingOrFetchedAll = loadingReports ? (
    <Loading />
  ) : (
    !canLoadMore && <Divider>You're all caught up</Divider>
  );

  return (
    <div>
      <div className={classes.range_picker_container}>
        <RangePicker
          size="large"
          allowClear={false}
          format="YYYY-MM-DD"
          disabledDate={(currentDate) =>
            currentDate.isAfter(moment()) ||
            currentDate.isBefore(moment(sourceCreatedAt).startOf('day'))
          }
          defaultValue={[moment().add(-1, 'd'), moment()]}
          data-testid="dateRangePicker"
          onCalendarChange={([from, to]: FixMe) => {
            if (onChangeDate) {
              onChangeDate({
                from: from?.format('YYYY-MM-DD 00:00:00'),
                to: to?.format('YYYY-MM-DD 23:59:59'),
              });
            }
          }}
        />
      </div>
      <div className={classes.reports_container}>
        {reports.length > 0 ? (
          <>
            <ReportHeader
              report={reports[0]}
              sourceName={sourceName}
              destinationName={destinationName}
            />
            {reports.map((report) => (
              <Report
                onClickRejected={onClickRejected}
                report={report}
                onClickRecords={onClickRecords}
                operationMetrices={
                  report.jobRunId === operationMetrices?.jobRunId &&
                  report.taskRunId === operationMetrices?.taskRunId
                    ? operationMetrices
                    : undefined
                }
              />
            ))}
            {loadingOrFetchedAll}
          </>
        ) : (
          noReportsView
        )}

        <div ref={endPageRef} />
      </div>
    </div>
  );
};

export default Syncs;
